import { useQuery } from "@tanstack/react-query";
import {
  getQueueLoad,
  getDbConnections,
  getAuthLogs,
  getErrorLogs,
  getAgentLogs,
  getHardwareStatus,
  getServiceStatus,
} from "../Api/monitoring";

export const useQueueLoad = () => {
  return useQuery({
    queryKey: ["queueLoad"],
    queryFn: getQueueLoad,
    refetchInterval: 10000,
  });
};

export const useDbConnections = () => {
  return useQuery({
    queryKey: ["dbConnections"],
    queryFn: getDbConnections,
    refetchInterval: 15000,
  });
};

export const useAuthLogs = () => {
  return useQuery({
    queryKey: ["authLogs"],
    queryFn: getAuthLogs,
    refetchInterval: 15000,
  });
};

export const useErrorLogs = () => {
  return useQuery({
    queryKey: ["errorLogs"],
    queryFn: getErrorLogs,
    refetchInterval: 15000,
  });
};

export const useAgentLogs = () => {
  return useQuery({
    queryKey: ["agentLogs"],
    queryFn: getAgentLogs,
    refetchInterval: 15000,
  });
};

export const useHardwareStatus = () => {
  return useQuery({
    queryKey: ["hardwareStatus"],
    queryFn: getHardwareStatus,
    refetchInterval: 5000,
  });
};

export const useServiceStatus = () => {
  return useQuery({
    queryKey: ["serviceStatus"],
    queryFn: getServiceStatus,
    refetchInterval: 5000,
  });
};
